import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "@app/../environments/environment";

@Injectable()
export class FirebaseDatabaseService {
    private emailCheckUrl: string;

    constructor(private readonly http: HttpClient) {
        this.emailCheckUrl = environment.firebaseCheckEmailWebsocketUrl;
    }

    public checkEmailExists$(email: string): Observable<string> {
        return this.http.get(`${this.emailCheckUrl}/${email}`, {
            responseType: "text",
        });
    }
}
